import {ChannelIdentitiesState} from '.';
import { GetterTree } from 'vuex';
import { AppState } from '../app';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';

export const getters: GetterTree<ChannelIdentitiesState, AppState> = {

	channelIdentities(state: ChannelIdentitiesState): ChannelIdentityViewModel[] {
		return state.channelIdentities;
	},
};
